import { FC, useEffect } from 'react';
import { Paper, Grid, Button, TextField } from '@material-ui/core';
import { useStyles } from './styles';
import { observer } from 'mobx-react-lite';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableRow from '@material-ui/core/TableRow';
import { Controller, useForm } from 'react-hook-form';
import { useStore } from 'hooks/useRootStore';
import { useMutation } from 'react-query';
import { useAppPreloader } from 'hooks/useAppPreloader';

export const EndUserAddressForm: FC = observer(() => {
  const classes = useStyles();
  const {
    endUserSettingsFormStore: { UserIPGenrate },
    notificationStore: { openNotification },
  } = useStore();

  const UserIPGenratereq = useMutation((data: any) => UserIPGenrate(data), {
    mutationKey: 'UserIPGenratereq',
    onSuccess: (e) => {
      openNotification('success', 'Saved!!');
    },
    onError: ({ message }: Error) => openNotification('error', message),
  });
  useAppPreloader(UserIPGenratereq.isLoading);

  const { control, handleSubmit } = useForm<any>();

  const onSubmit = (data: any) => {
    const ipAddressArray = data.ipAddress.split(',').map((ip: string) => ip.trim());
    const payload = { ipAddress: ipAddressArray };
    return UserIPGenratereq.mutate(payload);
  };

  useEffect(() => {
    document.title = 'EasyIdentity: Settings: Portal';
  }, []);

  return (
    <>
      <Grid className={classes.topText}>
        <p>
          Please provide a list of allowed IP addresses (comma separated) or an IP address block. Only these allowed IP
          addresses will be able to access the EasyIdentity portal. If left blank, then the EasyIdentity portal will be
          accessible from anywhere.
        </p>
      </Grid>
      <form onSubmit={handleSubmit(onSubmit)}>
        <Paper className={classes.paper}>
          <TableContainer style={{ display: 'flex' }}>
            <Table className={`${classes.border} ${classes.boxes}`} aria-label='simple table'>
              <TableBody>
                <TableRow>
                  <TableCell className={`${classes.border} ${classes.cellTitle}`}>Allowed IPs (CIDR) </TableCell>
                  <TableCell className={`${classes.border} ${classes.cellLink}`}>
                    {' '}
                    <Controller
                      key='1'
                      name='ipAddress'
                      control={control}
                      rules={{ required: true }}
                      render={({ field, fieldState: { invalid } }) => (
                        <Grid container className={classes.row}>
                          <TextField
                            {...field}
                            error={invalid}
                            placeholder='Allowed IPs (CIDR)'
                            helperText={invalid ? 'Required field' : ''}
                            className={`${classes.input} ${classes.cellInputLink}`}
                            InputProps={{ disableUnderline: true }}
                          />
                        </Grid>
                      )}
                    />
                  </TableCell>
                </TableRow>
              </TableBody>
            </Table>
            <span className={classes.text}> e.g : 192.168.1.14 , 192.168.1.18 </span>
          </TableContainer>
          <div className={classes.rightCol}>
            <Grid item xs={12} className={classes.btnContainers}>
              <Button className={classes.submitBtns} type='submit' variant='contained'>
                Update CIDR
              </Button>
            </Grid>
          </div>
        </Paper>
      </form>
    </>
  );
});
